import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["pageType", "url", "slug", "as", "title", "contentProps", "extraLinkProps"];
import React from 'react';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import BaseLink from '../../../../../atoms/Link';
import { isExternalPage } from '../../../../../services/pages';
import { LinkDisplayName } from '../../SiteNavigation.constants';
var defaultProps = {
  pageType: 'Internal',
  url: '',
  slug: '',
  as: 'span',
  title: null,
  contentProps: {},
  extraLinkProps: {}
};
function Link(_ref) {
  var pageType = _ref.pageType,
    url = _ref.url,
    slug = _ref.slug,
    as = _ref.as,
    title = _ref.title,
    contentProps = _ref.contentProps,
    extraLinkProps = _ref.extraLinkProps,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SemanticUIMenu.Item, _extends({
    link: true
  }, props), /*#__PURE__*/React.createElement(BaseLink, _extends({
    to: isExternalPage(pageType) ? url : slug,
    linkAs: as,
    title: title,
    internal: !isExternalPage(pageType),
    contentProps: contentProps
  }, extraLinkProps)));
}
Link.defaultProps = defaultProps;
Link.displayName = LinkDisplayName;
export default Link;